import { render, staticRenderFns } from "./customer-add-product-component.vue?vue&type=template&id=ff82bc84&scoped=true"
import script from "./customer-add-product-component.vue?vue&type=script&lang=js"
export * from "./customer-add-product-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff82bc84",
  null
  
)

export default component.exports